module.exports = __webpack_public_path__ + "img/p1.87cd4614.png";